import { useHistory } from "react-router-dom";
import useUserInfo from "../../../../../hooks/useUserInfo";
import { MainInfoUserWrapper, MainInfoWrapper } from "./styles";
import PubQR from "../pub-qr";

const UserInfo = ({
  onClickInfo,
  onClickQr,
  qrValue,
}: {
  onClickInfo: () => void;
  onClickQr: () => void;
  qrValue: string;
}) => {
  const { user } = useUserInfo();
  const history = useHistory();

  const formatPhoneNumber = (number: string | undefined) => {
    if (!number) return "-";

    const cleanNumber = number.replace(/\D/g, "");

    if (cleanNumber.length === 10) {
      return cleanNumber.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
    } else if (cleanNumber.length === 11) {
      return cleanNumber.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
    } else {
      return number;
    }
  };

  const formatBirthday = (value: string | undefined) => {
    if (!value) return "-";

    const [yyyy, mm, dd] = value.split("-");
    const yy = yyyy.slice(-2);

    return `${yy}/${mm}/${dd}`;
  };
  return (
    <MainInfoWrapper>
      <div className="title-button">
        <div className="title" onClick={onClickInfo}>
          POINT
        </div>
        <div
          className="qr-icon-wrapper"
          onClick={(e) => {
            onClickQr();
          }}
        >
          <PubQR qrValue={JSON.stringify(qrValue)} width="93%" height="93%" />
        </div>
      </div>
      <div className="header">
        <div className="name">NAME</div>
        <div className="item">
          <div className="seed">{user?.username}</div>
        </div>
      </div>
      <MainInfoUserWrapper onClick={() => history.push("/mypage")}>
        <div className="item">
          <div className="title">Birthday</div>
          <div className="value">{formatBirthday(user?.birthday)}</div>
        </div>
        <div className="item">
          <div className="title">Phone number</div>
          <div className="value">{formatPhoneNumber(user?.phoneNumber)}</div>
        </div>
      </MainInfoUserWrapper>
    </MainInfoWrapper>
  );
};

export default UserInfo;
